/* eslint-disable prettier/prettier */
export default {
  other_search: 'Search',
  crypto: {
    buy_card: 'Buy crypto with a credit card!',
    now_trading: 'Now trading is even easier and more convenient',
    order_amount: 'Order Amount',
    total: 'Total (including handling charges)',
    min_buy: 'Minimum Buy',
    max_buy: 'Maximum Buy',
    service_charge: 'Service Charge',
    purchase: 'Purchase instructions',
    price: 'The price of virtual currency is based on the current quotation rather than the final price.',
    payment: 'When the payment is completed, you can query the payment status in advcash.',
    questions:
      'If you have any questions in the exchange, you can get help by contacting advcash customer service hotline: + 44 2039 6615 42, customer service time: Monday-Friday 07:00-16:00 GMT.',
    powered: 'POWERED BY',
    total_fee: 'Total (including handling fee)',
    platform_advcash: 'The credit card exchange service is provided by the third-party platform advcash. Users must agree to the',
    rules: 'user agreement and rules',
    customer:
      'of the advcash platform when using the exchange service. If users have any problems in the exchange, they can get help by contacting the advcash customer service hotline + 44 2039 6615 42, customer service time: Monday-Friday 07:00-16:00 GMT. The biconomy platform will not be liable for any loss caused by or related to the use of the redemption function.',
    read: 'have read and agree',
    cancel: 'Cancel',
    confirm: 'Confirm',
    submitted: 'Submitted',
    buy_now: 'Buy Now',
    sign_in: 'Log In',
    title: 'Buy Crypto',
    anyway: 'Buy or receive crypto anyway you want!',
    partner:
      'We partner with multiple third-party payment providers to help you get crypto directly with your credit card or bank account. Note that choosing the payment method you will be directed to our third-party partner platform and in case of any questions, you can feel free to contact their customer support.',
    link: 'Check out the Market',
    PAYment: 'PAYment service',
    notNumber: 'Not a member?',
    sign_now: 'Sign up now',
  },
  invite: {
    friends: 'Invite Friends',
    up_to: 'Up to',
    rebate: 'Rebate',
    ratio_one: 'Rebate ratio (one-level)',
    ratio_two: 'Rebate ratio (two-level)',
    method: 'Invitation Method',
    link: 'Invitation Link',
    code: 'Invitation Code',
    poster: 'View Invitation Poster',
    overview: 'Overview',
    invitation: 'Invitation',
    rebates: 'Rebates',
    rebates_rank: 'Rebates Rank',
    ranking: 'Ranking',
    rank_account: 'Account',
    usdt: 'Total Rebates(USDT)',
    more: 'More',
    description: 'Rule Description',
    desc_1: '1.After 00:00, the invited friend is a valid friend, and the return time is the first day of the next month.',
    desc_2:
      '2.A invites friend B to perform registration authentication and transaction, and B invites friend C to perform registration authentication and transaction. Then A can get some commission rebate for B’s transaction on the next day, and A can also get some commission rebates for C’s transactions; Friend B can get some commission rebates for C’s transactions the next day. Similarly, if C invites D, then B can also get a partial commission rebate for D’s transaction the next day.',
    desc_3:
      '3.As long as the invited friend completes registration and authentication, the invitation is considered successful. Rebate will need to invite friends to generate transaction fee after successful invitation (if the friend registered without real name, transaction fee will not be included in rebate).',
    send: 'Select download poster to send to friends',
    download: 'Download',
    total_usdt: 'Total（USDT）',
    one_level: 'One-Level',
    two_level: 'Two-Level',
    valid_month: 'Valid one-level this month',
  },
};
